var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.771 18.286A1.834 1.834 0 0 0 9.6 16.457H5.943c0 1.006.823 1.829 1.828 1.829Zm5.943-5.486V7.771c0-2.834-1.92-5.12-4.571-5.76v-.64C9.143.64 8.503 0 7.77 0 7.04 0 6.4.64 6.4 1.371v.64c-2.651.64-4.571 2.926-4.571 5.76V12.8L0 14.629v.914h15.543v-.914L13.714 12.8Z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default ForwardRef;